<template>
    <el-row class="screen-logo" :gutter="20" type="flex">
        <el-col :span="6" class="logo-item create-logo">
            <upload class="logo-upload" :tip="$t('xian_zhi_fen_bian_lv_can_kao_ji_xing_fen_bian_lv_shou_ce')" :accept="'image/*'"
            :uploadSuccess="uploadSuccess"></upload>
        </el-col>
        <el-col :span="6" v-for="(item, index) in pictures" :key="index">
            <div class="logo-item">
                <img :src="item.url" @click="showPicture(item)"/>
                <p class="logo-item-text-info" @click="editLogo(item)">
                    <span>{{$t('bian_ji')}}</span>
                </p>
            </div>
        </el-col>
        <el-image-viewer
                v-if="pictureViewerVisible"
                :url-list="url"
                :on-close="closeViewer"/>
    </el-row>

</template>

<script>
    import Upload from '@/components/Upload'
    import ElImageViewer from "../../../../../node_modules/element-ui/packages/image/src/image-viewer";
    import {logoCreate, logoList} from '@/api/delivery/device/logo'
    export default {
        name: '',
        components: {
            ElImageViewer,
            Upload
        },
        mounted: function () {
            this.loadLogos()
        },
        data: function () {
            return {
                uploadVisible: false,
                pictureViewerVisible: false,
                url: [],
                pictures: [],
            }
        },
        methods: {
            closeViewer() {
                this.pictureViewerVisible = false
            },
            showPicture(item){
                let data = []
                data.push(item.url)
                this.url = data
                this.pictureViewerVisible = true
            },
            loadLogos() {
                logoList().then(res => {
                    this.pictures = res.data || []
                })
            },
            editLogo(item){
                this.$router.push({name: 'delivery.devices.screenManager.logo.detail', params: item})
            },
            uploadSuccess(url){
               let logo = {
                   url : url,
               }

                logoCreate(logo).then(res => {
                    logo.uuid = res.data
                    this.$message.success(this.$t('shang_chuan_cheng_gong'))
                    this.pictures.unshift(logo)
                })
            }
        },
    }
</script>

<style lang="scss">
    .screen-logo {
        margin-bottom: $padding;
        flex-flow: row wrap;
        align-content: flex-start;
        .logo-item {
            background-color: $bg_sec_color;
            border: .2rem;
            margin-bottom: $padding;
            img {
                width: 100%;
                height: 100%;
                cursor: pointer;
            }
            .logo-item-text-info {
                padding: $padding-5;
                font-size: .6rem;
                color: $f_sec_color;
                text-align: center;
                span {
                    cursor: pointer;
                }
                span:hover {
                    color: $f_color;
                }
                .look-devices {
                    margin-left: $padding-5;
                    display: inline-block;
                }
            }
        }

        .create-logo {
            background-color: transparent;
            .logo-upload {
                height: 100%;
                width: 100%;
            }
        }

    }
</style>
